import React from 'react';
import c from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Dumbo from '../../../../DeviationViews/Dumbo';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import s from './DeviationPromo.scss';

interface Props {
  href?: string;
  onClick?: () => void;
  biData?: BiEvent;
  heading: string;
  subheading: string;
  deviation?: PapiDeviation;
  attributionSlot?: React.ReactNode;
  logoSlot?: React.ReactNode;
  ctaSlot?: React.ReactNode;
}

const DeviationPromo: React.FC<Props> = ({
  href,
  onClick,
  biData,
  heading,
  subheading,
  deviation,
  attributionSlot,
  logoSlot,
  ctaSlot,
}) => {
  const { ref, dimensions } = useMeasureElementCookie(MeasuredCookieType.DEVIATION_SIDEBAR_PROMO, {
    cookieDim: 'width',
  });
  return (
    <PlainButtonOrLink className={s['root']} href={href} onClick={onClick} biData={biData}>
      <Section>
        <div ref={ref} className={s['top-section']}>
          <div className={s['deviation-wrapper']}>
            {deviation && (
              <>
                <Dumbo
                  deviation={deviation}
                  width={dimensions?.width}
                  height={224}
                  aria-hidden="true"
                  useCoverMode
                />
                {attributionSlot && <p className={s['attribution']}>{attributionSlot}</p>}
              </>
            )}
          </div>
          <Heading className={s['heading']}>{heading}</Heading>
          <p className={s['description']}>{subheading}</p>
        </div>
        <div className={s['divider']} />
        <div className={c(s['bottom-section'], !!logoSlot && s['two-sided'])}>
          {logoSlot}
          {ctaSlot}
        </div>
      </Section>
    </PlainButtonOrLink>
  );
};

DeviationPromo.displayName = 'DeviationPromo';

export default DeviationPromo;
